var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "player",
      staticClass: "lc-player",
      class: { "-with-countdown": _vm.shouldDisplayCountdown },
      style: { "background-image": "url(" + _vm.imageUrl + ")" },
      attrs: { id: "lc-player" },
    },
    [
      _vm.shouldDisplayCountdown
        ? _c("Countdown", { attrs: { date: _vm.stream.startsAt } })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }